import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { PaleState, ThunkDispatchFunc } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';
import { actions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';
import { type CheckboxDispatchProps, CheckboxFilter } from './CheckboxFilter';

export const FacilityFilter = () => {
    const dispatch = useDispatch<ThunkDispatchFunc>();

    const facetList = useSelector((s: PaleState) => s.results.facets.facilities);
    const checkboxValues = useSelector((s: PaleState) => s.filters.facilities);

    const facilitiesDisplay = displayValues?.amenities?.facilities ?? {};

    const checkBoxClick: CheckboxDispatchProps['checkBoxClick'] = (valueOrMap) => {
        dispatch(actions.filterCheckboxFacility(valueOrMap));
    };

    const fetchResultsProxy: CheckboxDispatchProps['fetchResults'] = (queryParams) => {
        dispatch(fetchResults(queryParams));
    };

    const hasOptions = useMemo(
        () => Array.isArray(facetList) && facetList.some((f) => Boolean(facilitiesDisplay[f.value])),
        [facetList, facilitiesDisplay],
    );

    return hasOptions ? (
        <CheckboxFilter
            id="facilityFilter"
            label="Fasiliteter"
            facetList={facetList}
            displayValues={facilitiesDisplay}
            checkboxValues={checkboxValues}
            checkBoxClick={checkBoxClick}
            fetchResults={fetchResultsProxy}
        />
    ) : null;
};
